import React from "react"
import PropTypes from "prop-types"
import { makeStyles} from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import Layout from "../components/layout"
import SignIn from "../components/SignIn/SignIn"
// import LogoutLink from "../components/LogoutLink/LogoutLink"

export const isBrowser = () => typeof window !== "undefined"

const useStyles = makeStyles(theme => ({
  root: {
    padding: "1em",
    margin: 0,
  },
  heading:{
    textAlign:"center",
  },
}))

const IndexPage = props => {
  const classes = useStyles()
  let organization = props.location.search.slice(5)
  if (isBrowser()) window.localStorage["organization"] = organization
  /*window.localStorage['lastName'] = ""
    window.localStorage['dob'] = ""
    window.localStorage['contact_url'] = ""
    window.localStorage['userID'] = ""
    */
  return (
    <Layout>
      <Paper className={classes.root}>
        <Typography className={classes.heading} variant="h2">
          Welcome!
        </Typography>
        <br></br>
        {/* {props.userAuthenticated ? (
          <>
            <LogoutLink />
          </>
        ) : ( */}
          <SignIn />
        {/* )} */}

        <br></br>
        <br></br>
      </Paper>
     </Layout>
  )
}

IndexPage.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default IndexPage
